import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createBudgetRevenue = createAsyncThunk(
  'budgetRevenue/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/budget-revenue', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      });
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create revenue entry');
    }
  }
);

// Get All
export const fetchAllBudgetRevenues = createAsyncThunk(
  'budgetRevenue/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/budget-revenue');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch revenues');
    }
  }
);

// Get By ID
export const fetchBudgetRevenueById = createAsyncThunk(
  'budgetRevenue/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/budget-revenue/${id}`);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch revenue entry');
    }
  }
);

// Update
export const updateBudgetRevenue = createAsyncThunk(
  'budgetRevenue/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.put(`/budget-revenue/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update revenue');
    }
  }
);

// Delete
export const deleteBudgetRevenue = createAsyncThunk(
  'budgetRevenue/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/budget-revenue/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete revenue');
    }
  }
);
